import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './oneday.routes';
import addHtml from './modal/add.html';
import XLSX from 'xlsx';

export class OneDayController {
    $http;
    $state;
    socket;
    awesomeThings = [];
    onedays = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location, $timeout, $state) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;
        this.$timeout = $timeout;
        this.$state = $state;

        this.languageType = [
            { value: 'pt', name: '葡语' },
            { value: 'es', name: '西语' },
            { value: 'en', name: '英语' },
        ]

        $scope.$on('$destroy', function () {
            socket.unsyncUpdates('oneday');
        });
    }

    $onInit() {
        if (this.$cookies.get('token')) {
            this.$http.get('/api/onedays/?getAll=true', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {

                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;
                        this.onedays = response.data.data;

                        this.socket.syncUpdates('onedays', this.onedays);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    search(val) {
        if (val === true) {
            this.currentPage = 1;
        }
        const payload = angular.copy(this.filters);

        const ret = {
            filters: payload || {},
            page: this.currentPage - 1,
            size: 20
        };

        if (this.$cookies.get('token')) {
            this.$http.get('/api/onedays/?getAll=true', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: ret
            })
                .then(response => {
                    if (response.data.data) {

                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.onedays = response.data.data;

                        this.socket.syncUpdates('onedays', this.onedays);
                    }
                });
        } else {
            this.$location.path('main')
        }


    }


    importExcel() {
        const onedays = this.onedays;
        const state = this.$state;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {

                $scope.vm = {};
                let excel_data = null;
                $scope.daoru = function (evt) {
                    /* wire up file reader */
                    const target = evt.target;
                    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        /* read workbook */
                        const bstr = e.target.result;
                        const wb = XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

                        /* grab first sheet */
                        const wsname = wb.SheetNames[0];
                        const ws = XLSX.WorkSheet = wb.Sheets[wsname];

                        /* save data */
                        this.inputdata = (XLSX.utils.sheet_to_json(ws, { header: 1 }));
                        excel_data = this.inputdata;

                        evt.target.value = "" // 清空
                    };
                    reader.readAsBinaryString(target.files[0]);

                }

                $scope.save = function (myForm) {
                    if (!excel_data) {
                        alert('请上传excel');
                    } else {
                        $http.post('/api/onedays/', excel_data).then((response) => {
                            if (response.status === 200) {
                                $uibModalInstance.close();
                                state.reload();

                            } else {
                                alert('格式错误');
                            }

                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
    }



    deleteOneDay(oneday, index) {
        this.$http.delete(`/api/onedays/${oneday._id}`).then(response => {
            if (response.status === 200) {
                this.onedays.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }


    // addSurvey() {
    //   const surveys = this.surveys;
    //   this.$uibModal.open({
    //     template: addHtml,
    //     size: 'lg',
    //     /*@ngInject*/
    //     controller: function($scope, $http, $uibModalInstance) {
    //       $scope.vm = {};
    //       $scope.save = function(myForm) {
    //         if (myForm.$valid === false) {
    //           return false;
    //         } else {
    //           $http.post('/api/surveys', $scope.vm).then((response) => {
    //             $uibModalInstance.close(response.data);
    //           }, (error) => {
    //             console.log(error);
    //           });
    //         }
    //       };
    //       $scope.cancel = function() {
    //         $uibModalInstance.close();
    //       };
    //     }
    //   })
    //     .result.then(function(ret) {
    //     if (ret) {
    //       surveys.push(ret);
    //     }
    //   }, function () {
    //   });
    // }

}

export default angular.module('tttApp.oneday', [uiRouter])
    .config(routing)
    .component('oneday', {
        template: require('./oneday.html'),
        controller: OneDayController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/oneday/oneday.component.js